import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "FixedAppointmentContent"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "mb40"
}
const _hoisted_5 = { id: "FixedAppointmentDate" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  class: /*#__PURE__*/_normalizeClass(`mt10`)
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "fs12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = {
  key: 2,
  class: "grey fs14"
}
const _hoisted_13 = {
  key: 2,
  class: ""
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "fs13 fw400"
}
const _hoisted_16 = {
  key: 2,
  class: "fs13 fw400"
}
const _hoisted_17 = ["href"]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  class: "fl centered rad6 skyblueBg noBorder fs12",
  style: {"width":"160px","height":"30px","line-height":"30px"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = { class: "w100" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "mt3 fw400" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = {
  key: 0,
  class: "fs12 dgrey mt4"
}
const _hoisted_29 = { class: "fs12 fw600" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = {
  key: 0,
  class: "fs14 fw600 grey arial mt5"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = {
  key: 1,
  class: "fs12 dgrey mt8"
}
const _hoisted_35 = { class: "fs11" }
const _hoisted_36 = { class: "fs14 fw600" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_39 = { key: 3 }
const _hoisted_40 = {
  key: 0,
  class: "fs12 skyblue fl"
}
const _hoisted_41 = ["src"]
const _hoisted_42 = {
  class: "fl centered rad6 skyblueBg noBorder mr20 mb10",
  style: {"width":"160px","height":"30px"}
}
const _hoisted_43 = ["href"]
const _hoisted_44 = { style: {"line-height":"30px","font-size":"12px"} }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_46 = { class: "" }
const _hoisted_47 = ["href"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_49 = { key: 1 }
const _hoisted_50 = ["src"]
const _hoisted_51 = {
  class: "fl pad10",
  style: {"width":"calc(100% - 100px)"}
}
const _hoisted_52 = { class: "fl mt3 mr10" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_57 = {
  key: 0,
  class: "w100 pad20 mt20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_ZoomMeetingContent = _resolveComponent("ZoomMeetingContent")!
  const _component_SelectableGroups = _resolveComponent("SelectableGroups")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.appo && _ctx.appo.status == 10)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: _normalizeClass(`fs28 fw600 arial ml20 ${_ctx.isSP ? `centered mt20 mr20` : `text-left`}`)
        }, [
          (_ctx.isInstantRoom)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " "))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.localFormat), 1),
                (!_ctx.isSP)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "  (" + _toDisplayString(_ctx.appo.duration) + _toDisplayString(_ctx.$t(`schedule.min`)) + ")", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/watch2.png`),
                          width: "16",
                          height: "16",
                          class: "mr7 mt2 ml2"
                        }, null, 8, _hoisted_9),
                        _createTextVNode(" " + _toDisplayString(_ctx.appo.duration) + " ", 1),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t(`schedule.min`)), 1)
                      ])
                    ])),
                _hoisted_11,
                (this.rm.userInfo.timezone_value && _ctx.showTimezone)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(this.rm.userInfo.timezone_value), 1))
                  : _createCommentVNode("", true)
              ])),
          (_ctx.hasOnlineMeetingUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_ctx.isInstantRoom)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t(`schedule.enter_from_this_link_for_instant_room`)), 1))
                  : (_ctx.isToday)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t(`schedule.enter_today_from_this_link`)), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t(`schedule.enter_from_this_link`)), 1)),
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    class: _normalizeClass(`fs12 skyblue ${_ctx.isSP ? `` : `fl`}`),
                    href: `${_ctx.appo.online_meeting.online_meeting_url}`,
                    target: "_blank",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openOnlineUrl(_ctx.appo.online_meeting.online_meeting_url)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(_ctx.Util.getURLFromAddress(`${_ctx.appo.location_name}`, `320x320`)),
                      height: "90",
                      width: "90",
                      class: _normalizeClass(`fl mr10`)
                    }, null, 8, _hoisted_18)
                  ], 10, _hoisted_17),
                  _createElementVNode("div", {
                    class: _normalizeClass(`fl pad10 mt4 ${_ctx.isSP ? `ofh` : ``}`),
                    style: {"width":"calc(100% - 100px)"}
                  }, [
                    _createElementVNode("a", {
                      href: _ctx.appo.online_meeting.online_meeting_url,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      class: "whiteColor",
                      "data-auth": "NotApplicable"
                    }, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t(`location.open_online_url`)), 1),
                      _hoisted_21
                    ], 8, _hoisted_19),
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("a", {
                        href: _ctx.appo.online_meeting.online_meeting_url,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "data-auth": "NotApplicable",
                        class: "fl mb10",
                        style: {"max-width":"80%"}
                      }, [
                        _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.truncate(_ctx.appo.online_meeting.online_meeting_url, 100)), 1),
                        _hoisted_26
                      ], 8, _hoisted_24),
                      _createVNode(_component_CopyButton, {
                        linkUrl: _ctx.appo.online_meeting.online_meeting_url,
                        gtagCategory: `調整ページオンライン会議URLコピー`,
                        class: "fl w20"
                      }, null, 8, ["linkUrl"])
                    ]),
                    _hoisted_27,
                    (_ctx.appo.online_meeting.online_meeting_account_email)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t(`location.online_meeting_account`)) + ": ", 1),
                          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.appo.online_meeting.online_meeting_account_email), 1),
                          _hoisted_30,
                          (_ctx.appo.online_meeting.online_meeting_zoom_host_key)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _withDirectives(_createElementVNode("img", {
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/key.png`),
                                  width: "18",
                                  height: "18"
                                }, null, 8, _hoisted_32), [
                                  [_directive_tooltip, `${_ctx.$t(`location.host_key_with_no_show`)}`]
                                ]),
                                _createTextVNode(" " + _toDisplayString(_ctx.appo.online_meeting.online_meeting_zoom_host_key), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_33
                        ]))
                      : _createCommentVNode("", true),
                    (
                                !_ctx.appo.online_meeting.is_owner_ug &&
                                !_ctx.appo.online_meeting.online_meeting_url.includes(`pwd=`) &&
                                _ctx.appo.online_meeting.online_meeting_password
                            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t(`location.passcode`)) + ":", 1),
                            _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.appo.online_meeting.online_meeting_password), 1)
                          ]),
                          _hoisted_37
                        ]))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                false
                  ? (_openBlock(), _createBlock(_component_ZoomMeetingContent, { key: 3 }))
                  : _createCommentVNode("", true),
                _hoisted_38
              ]))
            : (_ctx.appo.location_name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  (_ctx.Util.isUrl(_ctx.appo.location_name))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(_ctx.Util.getURLFromAddress(`${_ctx.appo.location_name}`, `320x320`, true)),
                          height: "90",
                          width: "90",
                          class: _normalizeClass(`fl mr10`)
                        }, null, 8, _hoisted_41),
                        _createElementVNode("div", {
                          class: "fl mt10",
                          style: {"width":"calc(100% - 100px)"},
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openOnlineUrl(_ctx.appo.location_name)))
                        }, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("a", {
                              style: {"width":"160px","color":"#fff","text-decoration":"none"},
                              href: _ctx.appo.location_name,
                              target: "_blank",
                              rel: "noopener noreferrer",
                              "data-auth": "NotApplicable"
                            }, [
                              _createTextVNode(" 　 "),
                              _createElementVNode("strong", _hoisted_44, _toDisplayString(_ctx.$t(`location.open_url`)), 1)
                            ], 8, _hoisted_43)
                          ]),
                          _hoisted_45,
                          _createElementVNode("p", _hoisted_46, [
                            _createElementVNode("a", {
                              style: {"text-decoration":"none"},
                              href: _ctx.appo.location_name,
                              target: "_blank",
                              rel: "noopener noreferrer",
                              "data-auth": "NotApplicable",
                              class: "skyblue fw400 fl mt3 mr20 mb10"
                            }, _toDisplayString(_ctx.truncate(_ctx.appo.location_name, 100)), 9, _hoisted_47),
                            _createVNode(_component_CopyButton, {
                              linkUrl: _ctx.appo.location_name,
                              gtagCategory: `調整ページカスタムURLコピー`,
                              class: "fl"
                            }, null, 8, ["linkUrl"])
                          ])
                        ]),
                        _hoisted_48
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createElementVNode("div", null, [
                          _createElementVNode("img", {
                            src: 
                                _ctx.$getAssetImageUrl(
                                    _ctx.Util.getURLFromAddress(
                                        `${_ctx.appo.selected_location?.address || _ctx.appo.location_name}`,
                                        `320x320`,
                                        true
                                    )
                                )
                            ,
                            height: "90",
                            width: "90",
                            class: _normalizeClass(`fl mr10`)
                          }, null, 8, _hoisted_50),
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.appo.location_name), 1),
                            (!_ctx.Util.isOnline(_ctx.appo.location_name))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "circle_button fw600 fl centered fs11 blueAround",
                                  style: {"padding":"4px 10px"},
                                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goGmap && _ctx.goGmap(...args)))
                                }, _toDisplayString(_ctx.$t(`location.confirm_google_map`)), 1))
                              : _createCommentVNode("", true),
                            _hoisted_53
                          ]),
                          _hoisted_54
                        ])
                      ]))
                ]))
              : _createCommentVNode("", true),
          _hoisted_55
        ], 2),
        _hoisted_56,
        (_ctx.appo && _ctx.appo.status == 10 && _ctx.appo.can_display_mag_in_room && _ctx.Util.isPresent(_ctx.appo.selectedMags))
          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
              _createVNode(_component_SelectableGroups, { appo: _ctx.appo }, null, 8, ["appo"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}